import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import CircularProgress from '@mui/material/CircularProgress';

import GroupeSelect from 'components/Shared/GroupeSelect';

import UtilisateurSelect from 'components/Shared/UtilisateurSelect';
import ReclamationPageHeader from 'components/Screens/ReclamationPage/ReclamationPageHeader';
// Import des composant de détails
import DetailsComplementairesRapidoTransportContent from './DetailsComplementairesRapidoTransportContent';


import DetailsComplementairesAffectationAutrui from './DetailsComplementairesAffectationAutrui';
import { green } from '@mui/material/colors';

const styles = {

    self: {
        paddingTop: '8px'
    },

    selfButton: {
        textDecoration: 'underline'
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },
    warningMessage: {
        whiteSpace: 'pre-line'
    }
};

const detailsContent = {
    'SERVICE_RAPIDO => SERVICE_TRANSPORT': DetailsComplementairesRapidoTransportContent
};


class AffectationDialog extends React.Component {

    render() {
        const { classes, open, affectation,
            onClickCancel, onClickAffecter, onClickAffecterForcer, onClickSelf,
            onChangeGroup, onChangeUser, onChangeObserver, onChangeDetails,
            disabledSelectUser, onlyUserId, validationInterdite,
            namespace, isAdding, warningMode,
            utilisateurCourant } = this.props;

        let warningTitle = '';
        let warningMessage = '';
        if (warningMode) {
            warningTitle = `Attention, le dossier après-vente ${affectation.reclamation.id} a été affecté à ${affectation.reclamation.groupe.libelle}` + (affectation.reclamation.utilisateur.id !== 0 ? ` / ${affectation.reclamation.utilisateur.nom}` : ``) + ` !`;
            warningMessage = `Voulez voulez quand même l'affecter à ${affectation.groupe.libelle}` + (affectation.utilisateur.id !== 0 ? ` / ${affectation.utilisateur.nom}` : ``) + ` ?`;
        }
        
        let DetailsContent = detailsContent[affectation.reclamation.groupe.code + ' => ' + affectation.groupe.code];

        if (DetailsContent === undefined) {

            if (validationInterdite !== 2 && affectation.utilisateur.id !== 0 && utilisateurCourant.id !== affectation.utilisateur.id) {
                DetailsContent = DetailsComplementairesAffectationAutrui;
            }
        }

        let fullDisabled = validationInterdite === 4;

        return (
            <Dialog
                maxWidth={'md'}
                open={open}>
                <DialogTitle>
                    <ReclamationPageHeader reclamation={affectation.reclamation} />
                </DialogTitle>

                <DialogContent>

                    <Dialog open={warningMode} disableEscapeKeyDown>
                        <DialogTitle>
                            {warningTitle}
                        </DialogTitle>
                        <DialogContent className={classes.warningMessage}>
                            {warningMessage}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={onClickCancel} color="primary" >Annuler</Button>
                            <Button
                                disabled={isAdding}
                                onClick={onClickAffecterForcer}
                                variant="contained"
                                color="secondary"
                            >
                                Affecter
                                {isAdding === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </Button>
                        </DialogActions>
                    </Dialog>



                    <Grid container spacing={3} mt={1}>
                        <Grid item xs={5} >
                            <GroupeSelect
                                disabled={affectation.selfOnly || fullDisabled}
                                value={affectation.groupe.id}
                                onChange={onChangeGroup}
                                all={false}
                                isRequired
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <UtilisateurSelect
                                namespace={namespace}
                                disabled={affectation.selfOnly || disabledSelectUser || fullDisabled}
                                onlyUserId={onlyUserId}
                                value={affectation.utilisateur.id}
                                onChange={onChangeUser}
                                all={false}
                                isRequired={false}
                            />
                            <div className={classes.self} hidden={affectation.selfOnly}>
                                <Button
                                    onClick={onClickSelf}
                                    variant="text"
                                    color="primary"
                                    className={classes.selfButton}
                                    disabled={fullDisabled}
                                >
                                    {`Me l'affecter`}
                                </Button>
                            </div>
                        </Grid>

                        <Grid item xs={3}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        disabled={fullDisabled}
                                        checked={affectation.observateur}
                                        onChange={onChangeObserver}
                                        value="Observer"
                                        color="secondary"
                                    />
                                }
                                label="Observer&nbsp;:&nbsp;"
                                labelPlacement="start"
                            />
                        </Grid>


                        {validationInterdite === 1 && (
                            <Grid item xs={12}>
                                <FormHelperText error>
                                    Le choix d'un groupe est obligatoire !
                                </FormHelperText>
                            </Grid>
                        )}

                        {validationInterdite === 2 && (
                            <Grid item xs={12}>
                                <FormHelperText error>
                                    Vous ne pouvez pas reaffecter au même groupe / utilisateur !
                                </FormHelperText>
                            </Grid>
                        )}
                        
                        {validationInterdite === 3 && (
                            <Grid item xs={12}>
                                <FormHelperText error>
                                   Un détail complémentaire requis est manquant !
                                </FormHelperText>
                            </Grid>
                        )}


                        {validationInterdite === 4 && (
                            <Grid item xs={12}>
                                <FormHelperText error>
                                    Vous n'êtes plus autorisé à modifier l'affectation de ce dossier après-vente !
                                </FormHelperText>
                            </Grid>
                        )}

                        {validationInterdite === 5 && (
                            <Grid item xs={12}>
                                <FormHelperText error>
                                    Vous ne pouvez pas affecter à votre groupe (contacter le pilote du groupe).
                                </FormHelperText>
                            </Grid>
                        )}

                        {DetailsContent !== undefined && (
                            <Grid item xs={12}>
                                <DetailsContent onChange={onChangeDetails} reclamationId={affectation.reclamation.id} />
                            </Grid>
                        )}
    
    
                    </Grid>

                </DialogContent>

                <DialogActions>
                    <Button onClick={onClickCancel} color="primary" >Annuler</Button>
                    <Button
                        disabled={(validationInterdite > 0) || isAdding}
                        onClick={onClickAffecter}
                        variant="contained"
                        color="secondary"
                    >
                        Affecter
                        {isAdding === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </Button>


                </DialogActions>
            </Dialog>
        );
    }
}

AffectationDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    affectation: PropTypes.object.isRequired,
    onClickCancel: PropTypes.func.isRequired,
    onClickAffecter: PropTypes.func.isRequired,
    onClickSelf: PropTypes.func.isRequired,
    onChangeGroup: PropTypes.func.isRequired,
    onChangeUser: PropTypes.func.isRequired,
    onChangeObserver: PropTypes.func.isRequired,
    onChangeDetails: PropTypes.func.isRequired,    
    disabledSelectUser: PropTypes.bool.isRequired,
    onlyUserId: PropTypes.number.isRequired,
    validationInterdite: PropTypes.number.isRequired,
    namespace: PropTypes.string.isRequired,
    isAdding: PropTypes.bool.isRequired
};

export default withStyles(styles)(AffectationDialog);


